import { useState } from "react";
import Modal from "../../../utils/components/Modal";
import Switch from "../../../utils/components/Switch";

const ExportModal = ({ show, setShow, onExport, translate }) => {
  const [fileFormat, setFileFormat] = useState("excel");
  const [exportAll, setExportAll] = useState(false);

  const handleApply = () => {
    onExport(fileFormat, exportAll);
    setShow(false);
  };

  const handleClose = () => {
    setShow(false);
  };

  return (
    <Modal
      title={translate("export_as")}
      positiveButtonNode={translate("apply")}
      negativeButtonNode={translate("cancel")}
      positiveButtonHandler={handleApply}
      negativeButtonHandler={handleClose}
      modalSize="sm"
      show={show}
      setShow={handleClose}
    >
      <div className="mb-4">
        <p className="text-muted small mb-2">{translate("forms.export_format")}</p>
        <div className="btn-group w-100" role="group">
          <input
            type="radio"
            className="btn-check"
            id="export-excel"
            checked={fileFormat === "excel"}
            onChange={() => setFileFormat("excel")}
          />
          <label
            className={`btn btn-outline-secondary w-50 ${fileFormat === "excel" ? "active" : ""}`}
            htmlFor="export-excel"
          >
            Excel
          </label>

          <input
            type="radio"
            className="btn-check"
            id="export-pdf"
            checked={fileFormat === "pdf"}
            onChange={() => setFileFormat("pdf")}
          />
          <label
            className={`btn btn-outline-secondary w-50 ${fileFormat === "pdf" ? "active" : ""}`}
            htmlFor="export-pdf"
          >
            PDF
          </label>
        </div>
      </div>

      <div className="d-flex align-items-center justify-content-between py-2 border-top">
        <div>
          <p className="mb-0 fw-semibold">{translate("forms.export_all")}</p>
          <p className="mb-0 text-muted small">{translate("forms.export_all_desc")}</p>
        </div>
        <Switch
          checked={exportAll}
          onChange={(e) => setExportAll(e.target.checked)}
        />
      </div>
    </Modal>
  );
};

export default ExportModal;
